module.exports = __webpack_public_path__ + "public/img/qiandao.53ea21ae.png";